import { GeocoderAddressComponent } from '../types/google';

export function getAddressFromComponents(address_components: GeocoderAddressComponent[]): string {
    const addressStr = '{street_number} {route}, {locality}, {administrative_area_level_1}';

    const components: Record<string, keyof Pick<GeocoderAddressComponent, 'long_name'|'short_name'>> = {
        'street_number': 'long_name',
        'route': 'long_name',
        'locality': 'long_name',
        'administrative_area_level_1': 'short_name'
    };

    return addressStr.replace(/{(\w+)}/g, function (match, key: string): string {
        const component = address_components
            .find(component => component.types.includes(key));
        
        return component ? component[components[key]] : '';
    });
}
